import { useOutletContext } from 'react-router-dom';
import Briefing from '@/pages/painel-pedidos/components/Briefing';
import PrioridadesHoje from './PrioridadesHoje';
import ComandoFinanceiro from './ComandoFinanceiro';
import NegociosQuentes from './NegociosQuentes';
import AlertasComerciais from './AlertasComerciais';
import InteligenciaResumo from './InteligenciaResumo';
import RelacionamentosImperdiveis from './RelacionamentosImperdiveis';

export default function VisaoGeral() {
  const { password } = useOutletContext<{ password: string }>();

  return (
    <div className="space-y-6">
      <ComandoFinanceiro password={password} />
      <RelacionamentosImperdiveis password={password} />
      <InteligenciaResumo password={password} />
      <AlertasComerciais password={password} />
      <NegociosQuentes password={password} />
      <Briefing password={password} refreshKey={0} />
      <PrioridadesHoje password={password} refreshKey={0} />
    </div>
  );
}